import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import '../report.css'

const WHOLE_YEAR = momentHelper.getMonth()
class ReportWorking extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      activePage: 1,
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      data: [],
      dataDetail: [],
      isRange: false,
      showDetail:false,
      empId:'',
      taskValue:'',
      fullname:'',      
      taskclosed:'',
      taskamount:'',
      isSubMenu:false,
      subMenu:[]
    }
    this.refTableId = 'ReportWorking-'+Math.ceil(Math.random()*100);
    this.refTableDetailId = 'ReportWorkingDetail-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month)
    }
  }

  getNumberFormat(value,digit=2) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getDetailSummary(field) {
    let {dataDetail} = this.state
    let total = 0
    dataDetail.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadData(year='',month='') {
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadKpi(year,month,this.props.type,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  loadDataRange(start='',end='') {
    ReportStore.loadKpiRange(start,end,this.props.type,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  onTableDetailCloseClick() {
    this.setState({subMenu:[],isSubMenu:false,empId:'',fullname:'',taskclosed:'',taskamount:'',showDetail:false,dataDetail:[]},()=>{
      if (this.props.onUpdateEventKey!=undefined)
        this.props.onUpdateEventKey(undefined)
    })
  }

  onRowClick(item) {
    let {year,month,isRange} = this.state
    let taskclosed = ''
    if (isRange)
        taskclosed = this.getStartDateRangeText()+' ถึง '+this.getEndDateRangeText()
    else
        taskclosed = momentHelper.getMonthText(month)+' '+year

    this.setState({loading:true,empId:item.employee_id,taskValue:item.task_value,fullname:item.first_name+' '+item.last_name,taskclosed:taskclosed,taskamount:item.task_count,subMenu:[{title:item.first_name+' '+item.last_name+' รหัส '+item.employee_id+' จำนวนงานซ่อม '+item.task_count,key:'s'+0}],isSubMenu:true},()=>{
        if (this.props.onUpdateEventKey!=undefined)
            this.props.onUpdateEventKey('s'+0)
    })
    ReportStore.loadKpiDetail(year,month,item.employee_id,this.props.type,item.task_value,(result)=>{
        this.setState({loading:false,dataDetail:result.data,showDetail:true})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            data.map((item,index)=>{
                return(
                    <tr key={index} onClick={this.onRowClick.bind(this,item)}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.employee_id}</td>
                        <td className='text-center'>{item.employee_name}</td>
                        <td className='text-center'>{item.task_name}</td>
                        <td className='text-center'>{item.task_count}</td>
                        {this.renderBodyByKpiType(item)}
                        <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                    </tr>
                )
            })
        )    
    }
  }

  renderBodyDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length==0) {
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            dataDetail.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.work_no}</td>
                        <td className='text-center'>{item.workclosed_date}</td>
                        <td className='text-center'>{item.car_registration_no}</td>                        
                        <td className='text-center'>{item.brand}</td>
                        <td className='text-center'>{item.model}</td>
                        <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                    </tr>
                )
            })
        )    
    }
  }

  renderHeaderByKpiType(){
    if(this.props.type==='office'){
      return [
        <th key={0} className='text-center' style={{width:'100px'}}>งานล่าช้า</th>,
        <th key={1} className='text-center' style={{width:'100px'}}>งานที่ยังเปิดอยู่</th>
      ]
    }else if(this.props.type==='mechanic'){
        return [
          <th key={2} className='text-center' style={{width:'100px'}}>งานแก้ไข</th>,
        ]      
    }

  }

  renderBodyByKpiType(item){
    if(this.props.type==='office'){
      return [
        <td key={0} className='text-center'>{item.tasklate_count}</td>,
        <td key={1} className='text-center'>{item.taskopen_count}</td>
      ]
    }else if(this.props.type==='mechanic'){
        return [
          <td key={2} className='text-center'>{item.tasklate_count}</td>,
        ]      
    }

  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = ''
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    let {type} = this.props
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income'>
          <thead>
            <tr>
              <th style={{display:'none'}} colSpan={8}>{(type==='mechanic'?'รายงานการปฏิบัติงานของช่าง ':'รายงานการปฏิบัติงานของออฟฟิศ ')+this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'150px'}}>รหัสพนักงาน</th>
              <th className='text-center' style={{width:'300px'}}>ชื่อนามสกุล</th>
              <th className='text-center' style={{width:'300px'}}>ประเภทงาน</th>
              <th className='text-center' style={{width:'100px'}}>จำนวนใบงาน</th>
              {this.renderHeaderByKpiType()}
              <th className='text-center' style={{width:'100px'}}>มูลค่างานซ่อม</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={4} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('task_count'),0)}</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('tasklate_count'),0)}</th>
              {type==='office'?
              <th className='text-center'>{this.getNumberFormat(this.getSummary('taskopen_count'),0)}</th>
              :''}
              <th className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderTableDetail() {
    return (
        <div className='display-overflow'>
          <table id={this.refTableDetailId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income'>
            <thead>
              <tr style={{display:'none'}}>
                <th colSpan={3}>ชื่อพนักงาน : {this.state.fullname}</th>
                <th colSpan={3}>ประจำ : {this.state.taskclosed}</th>
                <th>จำนวนงานซ่อม : {this.state.taskamount}</th>
              </tr>  
              <tr>
                <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                <th className='text-center' style={{width:'100px'}}>หมายเลขใบงาน</th>
                <th className='text-center' style={{width:'120px'}}>วันปิดงาน</th>
                <th className='text-center' style={{width:'120px'}}>เลขทะเบียน</th>
                <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
                <th className='text-center' style={{width:'100px'}}>รุ่น</th>
                <th className='text-center' style={{width:'100px'}}>มูลค่า</th>
              </tr>
            </thead>
            <tbody>
              {this.renderBodyDetail()}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={6} className='text-right'>ยอดรวมสุทธิ</th>
                <th className='text-right'>{this.getNumberFormat(this.getDetailSummary('amount'))}</th>
              </tr>
            </tfoot>
          </table>
        </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onMonthChange(val) {
    this.setState({
      month: val.value, isRange: false
    })
    this.loadData(this.state.year,val.value)
  }

  onYearChange(val) {
    this.setState({
      year: val.value, isRange: false
    })
    this.loadData(val.value,this.state.month)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = this.props.type=='mechanic'?'รายงานการปฏิบัติงานของช่าง.xlsx':'รายงานการปฏิบัติงานของออฟฟิศ.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportWorking&year='+this.state.year+'&month='+this.state.month+'&type='+this.props.type+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportWorking&start_date='+start+'&end_date='+end+'&type='+this.props.type+'&isRange=true'
    }
    
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcelDetail(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableDetailId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = this.props.type=='mechanic'?'รายงานการปฏิบัติงานของช่าง '+this.state.fullname+' รหัส '+this.state.empId+'.xlsx':'รายงานการปฏิบัติงานของออฟฟิศ '+this.state.fullname+' รหัส '+this.state.empId+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTableDetail(e) {
    let url = ''
    let param = 'PrintReportWorkingDetail&year='+this.state.year+'&month='+this.state.month+'&empId='+this.state.empId+'&taskValue='+this.state.taskValue+'&type='+this.props.type+'&fullname='+this.state.fullname+'&taskclosed='+this.state.taskclosed+'&taskamount='+this.state.taskamount

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.day+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>  
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            monthWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginLeft:'5px'}}>
            <PrintButtons
                onPrintTable={this.onPrintTable.bind(this)}
                onExportExcel={this.onExportExcel.bind(this)}
                marginLeft='0'
                width='auto'
            />
        </FormGroup>
      </Form>
    )
  }

  renderToolbarDetail() {
    return(
        <Form inline>
            <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginBottom:'5px'}}>
                <PrintButtons
                    onPrintTable={this.onPrintTableDetail.bind(this)}
                    onExportExcel={this.onExportExcelDetail.bind(this)}
                    marginLeft='0'
                    width='auto'
                />
            </FormGroup>
        </Form>
    )    
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'รายงานการปฏิบัติงานของ'+this.props.type=='mechanic'?'ช่าง':'ออฟฟิศ'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
        </Box.Header>
        <Box.Body>
          {showDetail?this.renderToolbarDetail():this.renderToolbar()}
          {!showDetail?this.renderDateRange():''}
          {showDetail?this.renderTableDetail():this.renderTable()}
          {/* this.renderPaging() */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
        {showDetail?
        <Box.Footer>
            <div className=" pull-right">
                <Button bsStyle='default' onClick={this.onTableDetailCloseClick.bind(this)}><FontAwesome name='table' />&nbsp;กลับหน้าตารางหลัก</Button>    
            </div>
        </Box.Footer>
        :''}
      </Box>
    )
  }
}

ReportWorking.defaultProps = {
  show: false,
  type: 'office'
}

export default ReportWorking;





// WEBPACK FOOTER //
// ./src/view/report/employee/ReportWorking.js